import { useToggle } from 'usehooks-ts'

import { UpgradePlanModal } from 'modules/ats/components/UpgradePlanModal'

export const useUpgradePlanModal = () => {
  const [showUpgradeModal, toggleShowUpgradeModal] = useToggle(false)

  return {
    UpgradePlanModal,
    showUpgradeModal,
    toggleShowUpgradeModal,
  }
}
